import { render } from "./ButtonPiscinas.vue?vue&type=template&id=85670e76&scoped=true"
import script from "./ButtonPiscinas.vue?vue&type=script&lang=js"
export * from "./ButtonPiscinas.vue?vue&type=script&lang=js"

import "./ButtonPiscinas.vue?vue&type=style&index=0&id=85670e76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85670e76"]])

export default __exports__